import './CTABanner.scss'
import {Link} from 'react-router-dom'
import config from '../../../../config'
import {DecoBall} from '../../../../global-styles/deco-styles/deco-ball/DecoBall'

export const CTABanner = ({children}) => {
    return (
        <section id={"cta-banner"} className={'cta-banner'}>
            <div className='cta-banner-bg'/>
            <div className={'inner-cta-banner'}>
                {children}
            </div>
            <svg className={'banner-stars'} xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none">
                <g opacity=".4" fill="#fff">
                    <path
                        d="m13.286 256.752 4.74 9.07 10.124 2.39-9.272 4.629-2.436 9.898-4.74-9.07-10.124-2.39 9.271-4.629 2.437-9.898ZM873.097 210.625l6.157 12.487 13.679 3.597-12.74 5.97-3.62 13.365-6.156-12.487-13.679-3.597 12.74-5.97 3.619-13.365ZM34.236 211.177l8.244 16.722 18.319 4.817-17.061 7.994-4.848 17.899-8.244-16.723-18.319-4.817 17.062-7.994 4.847-17.898ZM359.461 97.137l-8.054 1.67-3.933 7.028-1.724-7.828-7.237-3.83 8.054-1.668 3.933-7.03 1.725 7.83 7.236 3.828ZM1148.22 4.666l3.15 18.833 16.67 9.909-19.27 3.097-10.15 16.312-3.15-18.833-16.67-9.909 19.27-3.096 10.15-16.313ZM1172.75 60.219l-7.88 2.33-3.3 7.33-2.41-7.656-7.54-3.215 7.88-2.33 3.3-7.33 2.41 7.656 7.54 3.215Z"/>
                </g>
            </svg>
            <DecoBall style={{width: '24px', height: '24px', bottom: '124px', right: '18px', zIndex: 10}}></DecoBall>
            <DecoBall style={{width: '64px', height: '64px', bottom: '48px', right: '-1%', zIndex: 10}}></DecoBall>
            <DecoBall id={'heart'} style={{ height: '155px', width: '155px', bottom: '-80px', right: '-8px', zIndex: 51}}>
                <svg width="103" height="100" viewBox="0 0 119 116" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M39.5787 115.156L33.1793 105.348C25.7618 93.918 19.7143 84.152 15.0367 76.0502C10.3591 67.9484 6.8134 60.8503 4.39958 54.7559C1.98576 48.6615 0.599252 43.2833 0.240051 38.6214C-0.119149 33.9596 0.297896 29.4019 1.49119 24.9485C3.92965 15.848 9.01566 9.06528 16.7492 4.60032C24.4827 0.135353 32.8998 -0.877897 42.0002 1.56057C47.0345 2.90951 51.5415 5.25854 55.521 8.60767C59.5005 11.9568 62.6173 16.0086 64.8713 20.7632C69.2006 17.7726 73.9257 15.822 79.0467 14.9114C84.1676 14.0007 89.2452 14.2198 94.2795 15.5688C103.38 18.0072 110.163 23.0932 114.628 30.8268C119.093 38.5603 120.106 46.9773 117.667 56.0778C116.474 60.5312 114.557 64.6868 111.914 68.5445C109.272 72.4022 105.383 76.3666 100.245 80.4376C95.1074 84.5086 88.4876 88.8829 80.3858 93.5605C72.284 98.2381 62.1637 103.672 50.0249 109.862L39.5787 115.156ZM43.7812 99.4726C55.3062 93.637 64.8676 88.5463 72.4655 84.2007C80.0633 79.855 86.195 75.9466 90.8606 72.4754C95.5262 69.0043 98.9972 65.7319 101.273 62.6582C103.55 59.5845 105.142 56.3534 106.05 52.9649C107.606 47.1561 106.967 41.7966 104.132 36.8864C101.297 31.9762 96.9754 28.7429 91.1666 27.1864C86.6164 25.9672 82.0613 26.1215 77.5013 27.6494C72.9413 29.1773 69.4034 31.7314 66.8876 35.3117L55.8509 32.3544C55.4623 27.9959 53.6754 24.0151 50.4903 20.4119C47.3052 16.8086 43.4375 14.3974 38.8873 13.1782C33.0785 11.6217 27.719 12.2609 22.8088 15.0958C17.8986 17.9307 14.6653 22.2526 13.1088 28.0614C12.2009 31.4499 11.9641 35.0442 12.3986 38.8442C12.8331 42.6443 14.2028 47.2137 16.5078 52.5526C18.8128 57.8915 22.1688 64.3422 26.5758 71.9046C30.9829 79.467 36.718 88.6563 43.7812 99.4726Z"
                        fill="#F0F2F5"
                    />
                </svg>
            </DecoBall>
        </section>
    )
}


const Header = ({children}) => {
    return (
        <h3 className={'cta-banner-header'}>
            {children}
        </h3>
    )
}
CTABanner.Header = Header


const PrimaryCTA = ({children}) => {
    return (
        <Link className={'primary-cta'} to={config.root + '/signup'}>{children}</Link>
    )
}
CTABanner.PrimaryCTA = PrimaryCTA